module.exports = __webpack_public_path__ + "media/images/help_icon-533916e61fb90d32d04df050515cd4e6.png";